interface DriverInfoProps {
  driver: {
    id: string;
    name: string;
    cpf: string;
  } | null;
}

export default function DriverInfo({ driver }: DriverInfoProps) {
  if (!driver) {
    return (
      <div className="flex items-center gap-2">
        <div className="h-6 w-6 rounded-full bg-muted flex items-center justify-center">
          <span className="text-[10px] text-muted-foreground">?</span>
        </div>
        <div className="flex-1">
          <p className="text-xs font-medium text-muted-foreground">Sem motorista</p>
          <p className="text-[10px] text-destructive">Sem identificação</p>
        </div>
      </div>
    );
  }

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .substring(0, 2)
      .toUpperCase();
  };

  const formatCPF = (cpf: string) => {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  return (
    <div className="flex items-center gap-2">
      <div className="h-6 w-6 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center">
        <span className="text-[10px] font-semibold text-primary">
          {getInitials(driver.name)}
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-medium text-foreground truncate">
          {driver.name}
        </p>
        <p className="text-[10px] text-muted-foreground font-mono">
          {formatCPF(driver.cpf)}
        </p>
      </div>
    </div>
  );
}
